<template>
	<div>
	<div id="courses" class="row" v-for="article in news" :key="article.id">
		<div class="col mb-2">
			<h6>
				{{ article.date }} <span class="right-link"><a class="greeni" :href="article.link">Read more</a></span>
			</h6>
			<p>
				{{article.details}}
			</p>
		</div>
	</div>
	</div>
</template>

<script>
import getLatestNews from '../services/Spreadsheets'
export default {
	name: 'LatestNews',
	props: {},
	data() {
		return {
			news: [],
			loaded: false
		}
	},
	async mounted() {
		const resp = await getLatestNews.getLatestNews();
		this.news = resp.data
		this.loaded = true
	}
}
</script>

<style>

</style>